import { render, staticRenderFns } from "./CourseReviewAppHeaderProminent.vue?vue&type=template&id=4462283c&"
import script from "./CourseReviewAppHeaderProminent.vue?vue&type=script&lang=ts&"
export * from "./CourseReviewAppHeaderProminent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports